var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg6Terminology(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 30,
    viewBox: "0 0 40 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2128_248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3531 16.9379V21.9506H0.611328V3.61131H33.3531V7.92716",
    stroke: "#76808D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6197 9.7733V26.3887H4.87793V22.4029",
    stroke: "#76808D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.40625 10.0545H19.2682",
    stroke: "#76808D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.40625 15.5074H24.1587",
    stroke: "#76808D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2525 17.5492L28.8047 19.3464L28.8903 15.4218C28.8903 15.1651 28.9759 14.9083 29.1103 14.6882L35.0767 5.31075C35.2723 4.99287 35.6269 4.80948 35.9937 4.80948H37.3263C37.7543 4.80948 38.1455 5.06623 38.3289 5.45747L38.8424 6.61895C38.9891 6.94906 38.9646 7.3403 38.769 7.64595L32.7904 17.0479C32.6559 17.2557 32.4725 17.4269 32.2402 17.5492H32.2525Z",
    stroke: "#76808D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7175 5.2374L31.6289 14.8105",
    stroke: "#76808D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4847 17.0968L31.9834 15.8253C31.7511 15.2506 31.1887 14.8961 30.5774 14.9205L29.1836 14.9939",
    stroke: "#76808D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2128_248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.5639,
    height: 24,
    fill: "white",
    transform: "translate(0 3)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6Terminology);
export default __webpack_public_path__ + "static/media/6-terminology.1bb139ce8fb6568a53a6431d725e1bf5.svg";
export { ForwardRef as ReactComponent };